/**
 * The current month as the person reading the screen reckons it — V7-01 run,
 * found while verifying V7-03.
 *
 * This was `new Date().toISOString().slice(0, 7)`, which is **UTC**. For the
 * founder in Asia/Kolkata that is the previous month every night between
 * midnight and 05:30, and on the first of a month today's own row is simply
 * absent from the grid. V6-04 built `lib/workDate.ts` server-side precisely so
 * that a day means the same thing to everyone; the client's month picker never
 * got the same treatment.
 *
 * Local rather than the workspace timezone, deliberately: this is the initial
 * value of a month *picker*, and "this month" to the person holding the mouse
 * is their own calendar's month. The rows inside it are already keyed by the
 * server's work dates.
 */
export function currentMonth(at: Date = new Date()): string {
  return `${at.getFullYear()}-${String(at.getMonth() + 1).padStart(2, '0')}`;
}
